module.exports = __webpack_public_path__ + "img/t4-position.1ceb6265.png";